<template>
  <div class="j_datagrid_title_tools">
    <div>
      <j-pagination-box
        v-if="showPagination"
        :show-status="attrs.pagination.showPageNo === 'Y'"
        :pagination="pagination"
        :sideslide="sideslide"
        @previous="$emit('previous', $event)"
        @next="$emit('next', $event)"
        @page="$emit('page', $event)"
      />
    </div>
    <div class="__title__center">
      <component
        v-if="chartData && summaryChartComponent"
        :is="summaryChartComponent"
        :items="chartData"
        @request-action="onSummaryRequestAction"
      />
    </div>
    <div class="__title__right">
      <div
        v-if="attrs.showSearchInput === 'Y'"
        class="j_search type01"
        :style="sideslide ? sideSearchStyle : null"
        >
        <input
          type="search"
          name="q"
          placeholder="Filter and search"
          autocomplete="off"
          v-model="inputValue"
          @keyup.enter="emitFilter"
          :style="searchInputStyle"
        />
        <button
          v-if="inputValue"
          type="submit"
          style="margin-right: -5px"
          @click="clearFilter"
          >
          <i
            aria-hidden="true"
            title="Clear Text"
            class="v-icon v-icon--link mdi mdi-close v-theme--light"
          ></i>
        </button>
        <button
          type="submit"
          @click="emitFilter"
          >
          <v-icon>mdi-magnify</v-icon>
        </button>
      </div>
      <button
        v-if="attrs.showExcelExport === 'Y'"
        class="j_button type01 sky"
        @click="$emit('excel-download')"
        >
        <i class="jcon_download_02"></i>
        <span>EXCEL</span>
      </button>
      <button
        v-if="showActionButton"
        class="j_button type01 sky"
        @click="onActionButtonClick"
        >
        <span>{{ attrs.actionButton.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import __C from '../../../../src/primitives/_constant_'
import '../../../../src/assets/stylus/ui/component/_jDatagridTitle.scss'
import SummaryCharts from '../../../../src/components/DatatableSummaryCharts'

import { VIcon, VCol } from 'vuetify/components'
import JPaginationBox from '../JPaginationBox'

export default {
  name: 'j-data-grid-title-tools',
  components: {
    JPaginationBox,
    VIcon,
    VCol,
  },
  props: {
    sideslide: Boolean,
    attrs: { type: Object, default: () => ({}) },
    inputFilter: String,
    legendItems: { type: Object, default: () => null },
    pagination: { type: Object, default: () => null },
    chartComponentName: null,
    chartData: null,
  },
  data() {
    return {
      currentPage: 1,
      inputValue: this.inputFilter || '',
    }
  },
  computed: {
    ...mapState(__C.STORE_NAMESPACE.ACCOUNT, ['account']),
    showPagination() {
      return (
        this.attrs.pagination &&
        this.attrs.pagination.type === 'page' &&
        this.attrs.pagination.enabled !== 'N'
      )
    },
    sideSearchStyle() {
      return {
        border: '#ccc',
        backgroundColor: 'rgb(222, 222, 222)',
        opacity: '1',
      }
    },
    searchInputStyle() {
      return {
        color: '#fff',
        fontWeight: 'bold',
      }
    },
    showActionButton() {
      const actionButton = this.attrs.actionButton
      return (
        this.account.permitLevel <= __C.ACCOUNT.PERMISSION_LEVEL.DESIGNER &&
        actionButton &&
        actionButton.activate === 'Y'
      )
    },
    summaryChartComponent() {
      return this.chartComponentName
        ? SummaryCharts[this.chartComponentName]
        : null
    },
  },
  watch: {
    inputFilter(newVal) {
      if (newVal !== this.inputValue) {
        this.inputValue = newVal || ''
      }
    },
  },
  methods: {
    getLegendItemStyle(item) {
      const style = {
        color: item.tColor,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        marginRight: '1rem',
      }

      if (item._type === 'cell') {
        style.background = `linear-gradient(to right, ${item.bColor} 50%, #fff 50%)`
      } else if (item._type === 'color') {
        style.backgroundColor = item.bColor
      } else {
        style.paddingLeft = '3px'
        style.paddingRight = '3px'
      }

      return style
    },
    emitFilter() {
      this.$emit('input-filter', this.inputValue)
    },
    clearFilter() {
      this.inputValue = ''
      this.$emit('input-filter', '')
    },
    onActionButtonClick() {
      const actionButton = this.attrs.actionButton
      if (!actionButton) return
      this.$emit('request-action', {
        action: {
          target: 'slide-modal',
          component: actionButton.component,
        },
      })
    },
    onSummaryRequestAction(req) {
      this.$emit('request-action', req)
    },
  },
}
</script>
